module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley-rw"
  }, [_c('section', {
    staticClass: "body-rw Chapter-rw",
    attrs: {
      "epub:type": "bodymatter chapter",
      "id": "Chapter1"
    }
  }, [_c('div', {
    staticClass: "title-block-rw",
    attrs: {
      "id": "title-block7"
    }
  }, [_c('p', {
    staticClass: "title-num-rw",
    attrs: {
      "id": "title-num1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/TOC",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("One")])])]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "h21"
    }
  }, [_vm._v("Shay")]), _vm._v(" "), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "p20"
    }
  }, [_vm._v("You can tell a lot about a woman by the type of bra she wears. For instance, the silky black number clutched in my hand as I swing my skis on the chairlift, the one that makes my girls look some kind of wonderful, this one says: classy, yet conservative.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p21"
    }
  }, [_vm._v("“How far is it?” Lily asks, her white-blond hair almost camouflaged by the wisps of snow collecting on her lilac jacket.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p22"
    }
  }, [_vm._v("March in Aspen and the snow is heavier than in midwinter, the evergreens lining the runs sagging under pillows of the white stuff. With each blink, the frosted tips of my eyelashes brush my cheeks. “It’s closer to the end of the lift. Trust me, you can’t miss it.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p23"
    }
  }, [_vm._v("“You sure this is a good idea? We could come back tomorrow, and you could wear a different bra and carry this one so you don’t, you know, have to ski down without…” Her pale gray eyes settle on my jacket, about midchest. The area housing my braless boobs.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p24"
    }
  }, [_vm._v("Raven leans forward, her elbows resting on the safety bar, and she nudges Lily’s side. “What do you think’s going to happen? You think Shay’s bra-mando boobs will get caught under her skis and send her hurtling down the mountain?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p25"
    }
  }, [_vm._v("The snowboarder at the end of our four-pack chairlift snorts to himself while Lily sinks against the back of our seat, reverting to her quiet-as-a-mouse routine. Grown men have cowered in the face of Raven’s snark, but Lily’s backbone is lodged somewhere below her tailbone.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p26"
    }
  }, [_vm._v("I lick the snowflakes from my lips, knowing it’s now or never. When we passed the bra tree on our last ride up the chairlift, its branches weighted down with lingerie, I knew what I had to do. It was instinctual. Visceral. My need to shed this bra and all it represented couldn’t wait another second. One run and a quick trip to the washroom later, we got in line for this fateful ride. “Thanks for the concern, Lil, but I’m pretty sure my skiing ability won’t be affected by my lack of undergarments. The bra tree "), _c('i', [_vm._v("will")]), _vm._v(" be getting another ornament.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p27"
    }
  }, [_vm._v("“You really want to go through with it, though?” she asks as Snowboarder Dude cranes his neck to check out the black silk gripped in my gloved hand. “I mean, it’s "), _c('i', [_vm._v("the")]), _vm._v(" bra.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p28"
    }
  }, [_vm._v("She’s right. It’s not every day a girl comes across the perfect balance of lift and shape, cleavage and support, no extra skin pushing out the sides or back. Since its purchase, this has been my go-to bra. I wore it the day Richard passed the bar. I bought a new red dress, slinky and clingy in all the right places, but Richard did his usual, “Put on the black one I bought for you last month. The one with the lacy sleeves. I like how it slims your hips.” I followed his backhanded compliment with my usual, “Yeah, sure. Okay.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p29"
    }
  }, [_vm._v("When it came to Richard, my backbone slipped even lower than Lily’s.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p30"
    }
  }, [_vm._v("I tip my skis back and forth, remembering another “slimming” dress he picked out for me—a beaded black cut-out number—that I wore over this bra to celebrate Richard’s new job working for one of the top law firms in Toronto. It was the same day I was offered a promotion. The design firm I’d apprenticed at was closing shop to focus on their Montreal location, and I was asked to come along and help establish them as the front-runner of Canadian design. That night I wore my "), _c('i', [_vm._v("conservative")]), _vm._v(" bra under my "), _c('i', [_vm._v("doesn’t-make-my-hips-look-huge")]), _vm._v(" dress, agreeing with Richard as he spouted off all the reasons I needed to stay in Toronto to support him and his career.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p31"
    }
  }, [_vm._v("My spine pretty much disintegrated.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p32"
    }
  }, [_vm._v("But my favorite event, the moment that inspired this reality, this moment of truth, was the evening I donned "), _c('i', [_vm._v("the")]), _vm._v(" bra and a black dress expecting a proposal from Richard. After stumbling across an expensive Tiffany’s bill, I just knew. That was it. We were going to take that next step as partners—spouses in support of each other. His promises would be realized, and I’d finally quit my soul-sucking job designing retirement homes and stretch my wings. With his blessing, of course. What I got instead was: I think we’ve grown apart.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p33"
    }
  }, [_vm._v("More to the point, his dick grew toward Deena Wanger.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p34"
    }
  }, [_vm._v("For five years, I put him first. His wants. His needs. I wasn’t even second. A distant third, maybe. I dressed how he wanted, kept our apartment how he liked. The man had me on regular juice cleanses, for Christ’s sake. The brazen, confident girl who grew up in a small town got swallowed by the city. And Richard.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p35"
    }
  }, [_vm._v("Such an appropriate name, really. Even from birth, his parents knew he’d be a Dick.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p36"
    }
  }, [_vm._v("I huff out a breath, sending a cloud of vapor curling through the cool air. “Oh, I’m sure. This forever-tainted piece of lingerie will adorn that bra tree. It will be the crowning jewel.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p37"
    }
  }, [_vm._v("“You can’t just chuck that,” Snowboard Dude says, his mouth the only thing visible under his massive goggles and helmet. “There are rules.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p38"
    }
  }, [_vm._v("Raven turns to him, her charcoal eyes likely squinting. “Rules? It’s an evergreen tree on a ski slope covered with a pile of colorful bras and tacky necklaces. She can launch it if she wants.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p39"
    }
  }, [_vm._v("He shakes his head and leans more heavily on his elbows. “No way. Tradition is tradition. It’s gotta come from the evening’s conquest. You bag a chick, take her bra, and sling it on the tree to immortalize the moment. Like I said, tradition. So unless you ladies got busy together last night, or at lunch”—a lazy grin sweeps across his face—“then pocket the bra.” If he could see the tattoos inked over Raven’s olive skin, he’d maybe look a little less smug. One glance at her in a dark alley, and I’d cross to the other side.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p40"
    }
  }, [_vm._v("“Let me explain something.” She squares her shoulders toward him, head cocked in annoyance. “My girl here just got dumped by a total douche, so we three are hating on men. Since you’re the only dude on this chairlift, I’d say your choice is simple. She either hurls her bra on a tree covered in bras, or we channel our angry-girl hormones in your direction. What’ll it be?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p41"
    }
  }, [_vm._v("That sly grin slips from his face. “Whatever. You wanna spit on tradition, fine by me. But that shit is karmic.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p42"
    }
  }, [_vm._v("Raven’s long black ponytail glides along her jacket as she swings her helmeted head my way. “Forget him. That bra will be taking flight.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p43"
    }
  }, [_vm._v("I nod in agreement, my helmet bobbing with the movement. I may be hurt and pissed about how things ended with the Dick, but the relief is undeniable. Freeing. Both Raven and Lily made it known they thought I could do better, thought I’d lost a piece of myself to him (like two dress sizes), but I was too scared to step out on my own. Status quo was easier than no quo. I reverted to my prepubescent self, who stuttered and struggled to fit in. But knowing I might have said yes to a proposal because it was easy has anger bubbling up inside of me. I need to toss this bra, forget the Dick, and stop being such a doormat. I just wish I felt sexier in my equipment so I could get my flirt on with a rugged ski dude.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p44"
    }
  }, [_vm._v("This helmet is the anti-sexy.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p45"
    }
  }, [_vm._v("“Look, look, look!” Lily bounces beside me, the chairlift swaying in response. “That’s it, right?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p46"
    }
  }, [_vm._v("As we crest a rise, the pinks and reds and blues on the bra tree stand out in vibrant contrast to the white-tipped evergreens. A few skiers are attacking the narrow mogul run below us, their skis scraping and gliding between the massive bumps. God, I love that sound. Growing up in a ski town outside of Toronto meant the local slopes were in my backyard. Although our hills are glorified mounds, I practically skied from the womb, the blades an extension of my feet. Flying to places like Aspen never gets dull. Never repetitive. Ski trips with their mile-long runs, hot tubs, bars, and shops are my version of the typical girls’ beach vacation.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p47"
    }
  }, [_vm._v("The Dick only booked all-inclusive yawners.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p48"
    }
  }, [_vm._v("“That’s it, all right,” I say, my eyes locked on the tree.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p49"
    }
  }, [_vm._v("Snowboard Dude horks and spits over the side of the chair, likely aiming for the yeti splayed on the snow, skis crossed, butt in the air, a yard sale of his gear smattering the uniform bumps. "), _c('i', [_vm._v("Karma, my ass.")]), _vm._v(" I scan the tree up ahead, cataloguing each brassiere I can make out. The hefty beige one looks more like a straitjacket than a bra, the thick material folded over a lower branch. It screams: dull, trite, supportive, and dead boring. Above it, a flirty number in bright purple and swirling lace dangles, its owner definitely more sassy than mundane. Swallowing thickly, I glance at the black bra I once loved, hating what an easy read it is.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p50"
    }
  }, [_vm._v("Classy. Conservative. Proper. Poised.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p51"
    }
  }, [_vm._v("The perfect accessory to pressed suits and silk ties. The chosen undergarment to accent my slimming black dresses. "), _c('i', [_vm._v("The Dick.")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p52"
    }
  }, [_vm._v("At a time in my life when I was struggling to adapt to the city, overwhelmed and friendless and out of my depth, Richard swooped in with his easy charm and charisma. He was larger than life. He took me out, bought me things, and introduced me to his friends. Lily and Raven were away, all of us busy with our own studies, and I latched onto him, needy and desperate to belong. To not feel so alone. To not be the insecure, stuttering child I thought I had banished. Worried he’d move on and I’d have to start over, I molded myself into his perfect girl. I became "), _c('i', [_vm._v("that")]), _vm._v(" chick.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p53"
    }
  }, [_c('i', [_vm._v("Of course I’d rather suck kale through a straw than eat solid food.")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p54"
    }
  }, [_c('i', [_vm._v("Job promotion? Who needs it? I didn’t want a real life anyway.")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p55"
    }
  }, [_c('i', [_vm._v("Bring on the vanilla sex. Experimentation and excitement are overrated.")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p56"
    }
  }, [_vm._v("Every so often, though, I’d toss one of my hidden cookies into his smoothies…carbs and all.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p57"
    }
  }, [_vm._v("“You better get ready,” Raven says.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p58"
    }
  }, [_vm._v("We’re one chair back, and I raise my arm, readying to slingshot the bra, my past, and all things Richard into oblivion. As I do, a red lacy thing catches my eye. This piece of feminine lingerie is the perfect combination of sultry and flirtatious, the elegantly patterned fabric dipping low in the center, punctuated with a red bow. My heart quickens. "), _c('i', [_vm._v("That")]), _vm._v(" is the girl I was, once upon a time. The girl that got smothered by the Dick. That bra screams spontaneous and confident, a little wild and a lot of fun. It’s the one I’m buying the second we get to town.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p59"
    }
  }, [_vm._v("“Come on, Shay.” Lily nudges me. “If you wait any longer, you’re going to miss it.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p60"
    }
  }, [_vm._v("I clench my jaw, determination setting in.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p61"
    }
  }, [_vm._v("I draw my arm back, whip my wrist, and let the fabric go. It sails through the air in an elegant arc, my 34Cs taking flight, before being caught up in a gust of wind and tumbling down, down, down and landing smack on some guy’s head. Amid his "), _c('i', [_vm._v("what the fuck")]), _vm._v("s, the girls and I giggle as Snowboard Dude scoffs with a snarky “Karma.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p62"
    }
  }, [_vm._v("It may not have hit the tree, but that bra is out of my life. Along with the Dick.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p63"
    }
  }, [_vm._v("We push off the chairlift at the top, and I can’t keep my eyes from flitting around. "), _c('i', [_vm._v("I’m not wearing a bra.")]), _vm._v(" The secret is enthralling, wanton. A shiver of excitement runs down my spine, and a need for recklessness consumes me. Having been in ski racing programs as a kid, I can handle the expert terrain better than Lily and Raven. Right about now, I could use the adrenaline.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p64"
    }
  }, [_vm._v("“I say we call it early and have lunch in town. Last run of the day?” Lily asks as she zips the neck of her jacket higher to protect her pale skin. She tucks her blond strands into the back.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p65"
    }
  }, [_vm._v("Raven jumps up and down, her skis smacking the hard-packed snow. “Bet your ass it is. There’s a hot tub and glass of wine with my name on it.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p66"
    }
  }, [_vm._v("I eye the large terrain map at the top of the lift. The girls will want to take an intermediate blue run down, but those expert double black diamonds have my name on them. The bra is gone, my spine is back, and the Dick is out of my life. “Why don’t you guys take Ruthie’s Run? I’d rather take Schiller over to Corkscrew. I’ll meet you at the bottom.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p67"
    }
  }, [_vm._v("Raven pushes off on her poles until we’re almost chest to chest, her skis beside mine. She snaps her goggles onto her helmet and looks into my eyes. “Is that the old Shay in there? Has she come out to play?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p68"
    }
  }, [_vm._v("A couple of guys ski past us, practically colliding as they ogle Raven. Even in her anti-sexy helmet, she draws a crowd. As a teen, I’d catch myself staring at her olive skin, wishing I were sexy and striking with a sheath of shiny black hair. I grew to like my unruly mass of brown curls and wore them down to my waist, thick and untamed. Until I met the Dick, that is. The Dick has a preference for straight hair.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p69"
    }
  }, [_vm._v("So began the era of the straightener and singeing my hair into submission.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p70"
    }
  }, [_vm._v("“Yes, bitch, I’m back,” I say. “With a vengeance.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p71"
    }
  }, [_vm._v("I grab her goggles and snap them onto her face, eliciting a gratifying “Fuck” from her. She scowls and adjusts the frames.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p72"
    }
  }, [_vm._v("I tighten my boot buckles then straighten up and grab my poles, eager to feel the wind blast my face. With each movement my breasts move freely, and I grin wider. “I’ll meet you guys at the condo.” I’m about to push off when I add, “And we’re not going to one of those lame pubs again to hang with a bunch of stoners. Tonight, we’re picking up hot ski dudes.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p73"
    }
  }, [_vm._v("Lily tips her head back and groans. “What am I supposed to do while you two are seducing unsuspecting guys? I doubt Kevin would be too happy about me living it up in Aspen.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p74"
    }
  }, [_vm._v("“That’s easy,” Raven says. “Join us. Kevin’s a good guy and all, but that relationship of yours is beyond incestuous. Lines need to be drawn when you have naked bath-time pictures together.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p75"
    }
  }, [_vm._v("Lily tightens her lips until they match her alabaster skin. “We were neighbors, Raven. "), _c('i', [_vm._v("Neighbors.")]), _vm._v(" And so what if I’ve known him forever. He gets me.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p76"
    }
  }, [_vm._v("When Raven yawns in Lily’s face, I skate past them and call, “Don’t take forever. We’re shopping for bras before we head out.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p77"
    }
  }, [_vm._v("With that, I’m off, snow crunching, gusts of cool air snapping at my cheeks. There’s nothing as freeing as carving across the hill, edging into large, swooping turns as my skis dig deeper and my thighs burn. Nothing exists but the movement. The speed. The effortless up and down. And I’m not wearing a bra.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p78"
    }
  }, [_vm._v("The first section of moguls is tough. I land hard between the bumps, using my poles and the momentum to propel me into each sharp turn. "), _c('i', [_vm._v("Smack. Crunch. Skid.")]), _vm._v(" My blood pumps. My muscles grind. It’s my second day skiing, and the altitude and thin air are forcing my lungs to work double-time. The rhythm is unrelenting, exhausting, and by the time I finish the second section, sharp pangs slice through my chest. And the boob sweat is undeniable.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p79"
    }
  }, [_vm._v("I rest my upper body on my poles as a guy just ahead of me bails on his face. I can’t help laughing, and he gives me the finger. The snow has stopped falling, stillness in its place. My heart pounds in my ears. I stare down the hill, regretting my decision to do a marathon’s worth of moguls on my last run.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p80"
    }
  }, [_vm._v("My legs are noodles, my breasts hurt from bouncing, and "), _c('i', [_vm._v("God")]), _vm._v(", the boob sweat.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p81"
    }
  }, [_vm._v("I maneuver my black jacket and press my long underwear top just so, hoping to mop up the uncomfortable wetness. As I shift to the left, I notice a break in the trees. I glance down the till-death-do-us-part run then back at the path. Better to bushwhack through the glades than have my braless and sweaty self rescued by the ski patrol.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p82"
    }
  }, [_vm._v("Forcing my legs to move, I push forward and squeeze through the opening, dodging the trees as I pick my way toward the next run. There’s a steep dip past the last line of branches, the perfect ramp to shoot me onto the groomed trail. A quick breath, a shift of my stance, and I catapult myself forward, gaining momentum. I hit the edge of the run perfectly. My legs relax, the blades on my feet glide, and I’m so relieved not to be pounding the moguls that I let my skis fly. For a moment. Like a second. The length of time it takes for some jerk to blindside me and send me on my ass.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p83"
    }
  }, [_vm._v("I haven’t fallen while skiing since forever. I ski fast and hard but always in control. It’s a good thing. Hard-packed snow is about as soft as concrete. My left butt cheek smarts, a bruise no doubt forming, and I immediately regret laughing at that other dude’s face-plant earlier. Distant grumbles carry through the frosty air as I gingerly pick myself up and stretch my legs. With all body parts intact, I glance at the idiot a few feet below who skied into me.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p84"
    }
  }, [_vm._v("My jaw almost hits the snow.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p85"
    }
  }, [_vm._v("If a hot ski dude is what I’m after, fate just intervened. His helmet is off as he inspects what could be a crack in his goggles, and oh, my God, "), _c('i', [_vm._v("that hair")]), _vm._v(". Dirty blond and shoulder-length, tousled in a careless, sexy way that has me picturing my hands dragging through it. Add the stubble, the wide shoulders, and the tight booty that is unmistakable even in his ski pants, and I’m about to land on my ass again.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p86"
    }
  }, [_vm._v("Richard looked nothing like this guy. His short black hair was always tidy, each strand gelled in place. He was good-looking in a "), _c('i', [_vm._v("GQ")]), _vm._v(" way with his cut cheekbones and Armani style, and Lord knows I found him attractive. When I’d browse his selection of men’s magazines in our apartment, though, I didn’t linger on the clean-cut images of guys in suits with their button-down shirts and silk ties. I’d pause on the men in the jeeps. The ones climbing a mountain, three-day stubble accentuating a strong jaw. Like hot ski dude right in front of me. Maybe it was because those guys were the polar opposite of the Dick, or maybe I don’t have a “type.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p87"
    }
  }, [_vm._v("When Mountain Guy stops checking over his gear, he swivels his upper body toward me, that shoulder-length hair doing some sort of model thing as he rakes a hand through the layered strands. “Next time you merge onto a run, you should look uphill so you don’t run someone down. And you owe me a pair of goggles. These are trashed.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p88"
    }
  }, [_c('i', [_vm._v("Come again?")]), _vm._v(" The throbbing pain on my butt returns, along with a searing anger that has me shaking. He "), _c('i', [_vm._v("may")]), _vm._v(" be kind of right, but his tone and righteousness snaps my spine straight. I’m tired of taking crap. Tired of pussyfooting around guys because they think they run the world. Normally, I’d be all "), _c('i', [_vm._v("I’m sorry")]), _vm._v(" and "), _c('i', [_vm._v("it won’t happen again")]), _vm._v(", but I tossed that bra and that girl off a chairlift. “You can’t be serious. You totally blindsided me. Skied right into me. I’m not buying you squat.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p89"
    }
  }, [_vm._v("He stretches his neck, the shorter strands of hair by his chin falling across his face. He slings his small pack off his shoulders, unzips it, and shoves the damaged goggles inside, then he straightens and flicks "), _c('i', [_vm._v("that hair")]), _vm._v(". “The skier coming down has right of way. It isn’t rocket science. If I were a kid, that shit could’ve been a lot worse than some cracked goggles. So pay attention the next time you barrel onto a hill.” He shoots me a blistering look, like the dude owns the freaking mountain. Like I’ve never skied before. Then he mutters, “Idiot.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p90"
    }
  }, [_vm._v("Come to think of it, I do have a type. I’m pretty sure it’s Ass. Hole.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p91"
    }
  }, [_vm._v("“Get over it.” I jab my gloved middle finger in the air, fist my poles, and push off, skiing past his cute butt and model hair as the word “Bitch” follows behind me.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p92"
    }
  }, [_vm._v("I don’t glance back. I ski hard, taking wide, sweeping turns, picking up as much speed as possible, leaving the Asshole and my anger behind, because "), _c('i', [_vm._v("wow")]), _vm._v(", was that liberating. My skis are barely on the snow, the wind whipping something fierce, my breasts unrestrained. This must be what crack feels like. Or eating the largest bowl of Lucky Charms. Marshmallow-only Lucky Charms. Now I just want to let loose and swear a bunch and speak my mind. And buy Lucky Charms.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p93"
    }
  }, [_vm._v("And that red bra.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22cf2179","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/s003-Chapter-001.vue
// module id = 66
// module chunks = 0